<ng-container>
  <span [@burgerMenuLine1]="open ? 'open' : '*'"></span>
  <span [@burgerMenuLine2]="open ? 'open' : '*'"></span>
  <span [@burgerMenuLine3]="open ? 'open' : '*'"></span>
</ng-container>
